/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { currencySymbolMapping } from '../../../../CommonComponent/staticValues'

export default function ProcessingModal({ isOpen, onClose, sale, totalAmount }) {
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => setProgress(99), 50)
            return () => clearTimeout(timer)
        } else {
            setProgress(0)
        }
    }, [isOpen])

    const formattedAmount = sale
        ? `${currencySymbolMapping[sale.currency?.toUpperCase()] ?? ''}${Number(totalAmount).toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
        : ''
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[99]" onClose={() => {}}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-80" />
                </Transition.Child>
                <div className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full transform overflow-hidden rounded-[10px] bg-white
                                text-left align-middle shadow-xl transition-all relative
                                min-[640px]:mx-auto min-[640px]:mt-7 min-[640px]:min-h-[calc(100%-3.5rem)]
                                min-[640px]:max-w-[520px]">
                                
                                <div className="flex items-center justify-center px-6 pb-4 pt-10">
                                    <h2 className="text-[22px] font-medium text-[#343434] text-center" data-testid="processingModal">Payments processing</h2>
                                </div>

                                <div className="mx-10 mb-10 border border-[#DEDEDE] rounded-[10px] p-5">
                                    <div className='grid sm:grid-cols-2 text-[#343434]'>
                                        <div className="mb-3">
                                            <p className="text-[10px] font-medium mb-1">Order number</p>
                                            <p className="text-[16px] text-[#343434] font-medium">{sale?.order_number ?? '-'}</p>
                                        </div>
                                        <div className="mb-3">
                                            <p className="text-[10px] font-medium mb-1">Customer Name</p>
                                            <p className="text-[16px] text-[#343434] font-medium">{sale?.name ?? '-'}</p>
                                        </div>
                                    </div>
                                    <div className="mb-4">
                                        <p className="text-[10px] font-medium mb-1">Order total</p>
                                        <p className="text-[16px] text-[#343434] font-medium">{formattedAmount? formattedAmount : '-'}</p>
                                    </div>

                                    <div>
                                        <p className="text-[10px] font-medium mb-2">Progress</p>
                                        <div className="h-2 bg-[#E6E6E6] rounded-full overflow-hidden">
                                            <div
                                                className="h-full bg-[#5DA93D] rounded-full"
                                                style={{
                                                    width: `${progress}%`,
                                                    transition: 'width 5s ease-in-out',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}
